import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useTradeDraftQuote(path, payload, enabled) {
  const { user } = useAuth();
  const signature = JSON.stringify(payload);
  const [settled, setSettled] = useState(signature);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(signature), 180);
    return () => clearTimeout(timer);
  }, [signature]);
  const query = useQuery({
    queryKey: ["trade-draft-quote", user?.id, path, settled],
    queryFn: async ({ signal }) => (await api.post(path, JSON.parse(settled), { signal })).data,
    enabled: !!user && enabled && signature === settled,
    retry: false, staleTime: 0,
  });
  const loading = enabled && (signature !== settled || query.isPending || query.isFetching);
  return { quote: signature === settled && !query.isFetching ? query.data : null, loading,
    error: !loading && query.isError ? apiError(query.error, "Cannot value this trade.") : "",
    refresh: query.refetch };
}